import React from 'react';

const BlackTeaIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <radialGradient id="blacktea-bg" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#f3e8ff" />
        <stop offset="100%" stopColor="#ede9fe" />
      </radialGradient>
      <linearGradient id="blacktea-glass" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#a16207" />
        <stop offset="100%" stopColor="#78350f" />
      </linearGradient>
    </defs>
    <ellipse cx="32" cy="54" rx="18" ry="6" fill="#78350f" opacity="0.25" />
    <circle cx="32" cy="24" r="20" fill="url(#blacktea-bg)" opacity="0.15" />
    <rect
      x="20"
      y="10"
      width="24"
      height="36"
      rx="12"
      fill="url(#blacktea-glass)"
      stroke="#fff"
      strokeWidth="2"
    />
    <rect x="24" y="14" width="16" height="28" rx="8" fill="#fde68a" opacity="0.7" />
    <ellipse cx="32" cy="10" rx="12" ry="4" fill="#fde68a" />
  </svg>
);

export default BlackTeaIcon;
